// eslint-disable-next-line import/prefer-default-export
export const getSectionOfArray = <T>(
  list: Array<T>,
  sectionNumber: number,
  sectionSize: number
): Array<T> => {
  if (!list || list.length === 0) return []

  const start = sectionSize * (sectionNumber - 1)
  const end = start + sectionSize

  return list.slice(start, end)
}
